export default __webpack_public_path__ + "static/media/EVS.56708891.jpg";